import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCurrentRole } from '../redux/slices/currentUserSlice';

const RoleProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated } = useSelector((state) => state.currentUser);
  const role = useSelector(selectCurrentRole);

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  if (allowedRoles.includes(role)) {
    return children;
  }
  return <Navigate to="/" />;
};

export default RoleProtectedRoute;
